import { render } from "./BasePatientFilter.vue?vue&type=template&id=e86552e0&scoped=true"
import script from "./BasePatientFilter.vue?vue&type=script&lang=js"
export * from "./BasePatientFilter.vue?vue&type=script&lang=js"

import "./BasePatientFilter.vue?vue&type=style&index=0&id=e86552e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86552e0"]])

export default __exports__